export const adminOrganizationMetaTags = (params: { organizationId: number }) =>
  `organizationId:${params.organizationId}}`;
